/**
 * 반응형 디바이스 브레이크포인트 상수
 */

/**
 * 디바이스 타입 (문자열)
 */
export const DEVICE_MODE = {
    TABLET: "TABLET",
    LAPTOP: "LAPTOP",
    DESKTOP: "DESKTOP",
    DEFAULT: "DEFAULT",
};

/**
 * 디바이스별 브레이크포인트 (px)
 *
 * - TABLET:  ~ 1023px      (down(1024))
 * - LAPTOP:  1024 ~ 1439px (down(1440))
 * - DESKTOP: 1440 ~ 1919px (down(1920))
 * - DEFAULT: 1920px ~      (위 셋에 모두 해당하지 않는 경우)
 */
export const DEVICE_BREAKPOINT = {
    TABLET: 1024,
    LAPTOP: 1440,
    DESKTOP: 1920,
    DEFAULT: 2160,
};

/**
 * 디바이스 코드 (숫자)
 * 큰 숫자 = 작은 화면
 */
export const DEVICE_CODE = {
    TABLET: 3,
    LAPTOP: 2,
    DESKTOP: 1,
    DEFAULT: 0,

    // 레거시 호환 별칭 (서버 설정 데이터의 show/hidden 키 매핑)
    MOBILE: 3,
    TABLET_L: 3,
    LAPTOP_L: 2,
};
